import React, { useState } from "react";

// Mapeo de códigos a emojis
const flagMap = {
  us: "🇺🇸",
  gb: "🇬🇧",
  jp: "🇯🇵",
  fr: "🇫🇷",
  it: "🇮🇹",
  br: "🇧🇷",
  co: "🇨🇴",
  de: "🇩🇪",
  in: "🇮🇳",
  ca: "🇨🇦",
  kr: "🇰🇷",
  au: "🇦🇺",
  es: "🇪🇸",
  mx: "🇲🇽",
  id: "🇮🇩",
  nl: "🇳🇱",
  sa: "🇸🇦",
  tr: "🇹🇷",
  ch: "🇨🇭",
  tw: "🇹🇼",
  se: "🇸🇪",
  pl: "🇵🇱",
  be: "🇧🇪",
  th: "🇹🇭",
  ar: "🇦🇷",
  no: "🇳🇴",
  at: "🇦🇹",
  ae: "🇦🇪",
  ng: "🇳🇬",
  il: "🇮🇱",
  za: "🇿🇦",
  ie: "🇮🇪",
  hk: "🇭🇰",
  my: "🇲🇾",
  sg: "🇸🇬",
  ph: "🇵🇭",
  pk: "🇵🇰",
  cl: "🇨🇱",
  fi: "🇫🇮",
  bd: "🇧🇩",
  eg: "🇪🇬",
  vn: "🇻🇳",
  pt: "🇵🇹",
  cz: "🇨🇿",
  ro: "🇷🇴",
  nz: "🇳🇿",
  gr: "🇬🇷",
  iq: "🇮🇶",
  qa: "🇶🇦",
  kz: "🇰🇿",
  hu: "🇭🇺",
  kw: "🇰🇼",
  ua: "🇺🇦",
  ma: "🇲🇦",
  sk: "🇸🇰",
  ec: "🇪🇨",
  lk: "🇱🇰",
  ke: "🇰🇪",
  bg: "🇧🇬",
  cr: "🇨🇷",
  uy: "🇺🇾",
  hr: "🇭🇷",
  by: "🇧🇾",
  lb: "🇱🇧",
  lt: "🇱🇹",
  si: "🇸🇮",
  rs: "🇷🇸",
  az: "🇦🇿",
  jo: "🇯🇴",
  tn: "🇹🇳",
  bh: "🇧🇭",
  lv: "🇱🇻",
  ee: "🇪🇪",
  cy: "🇨🇾",
  is: "🇮🇸",
  cn: "🇨🇳",
  am: "🇦🇲",
  al: "🇦🇱",
  ba: "🇧🇦",
  mk: "🇲🇰",
  md: "🇲🇩",
  me: "🇲🇪",
  ge: "🇬🇪",
  uz: "🇺🇿",
  af: "🇦🇫",
  np: "🇳🇵",
  mm: "🇲🇲",
  kh: "🇰🇭",
  la: "🇱🇦",
  mn: "🇲🇳",
  bt: "🇧🇹",
  mv: "🇲🇻",
  bn: "🇧🇳",
  tl: "🇹🇱",
  lu: "🇱🇺",
  mc: "🇲🇨",
  sm: "🇸🇲",
  ad: "🇦🇩",
  li: "🇱🇮",
  va: "🇻🇦",
  dz: "🇩🇿",
  ao: "🇦🇴",
  et: "🇪🇹",
  cd: "🇨🇩",
  tz: "🇹🇿",
  ug: "🇺🇬",
  sd: "🇸🇩",
  mz: "🇲🇿",
  gh: "🇬🇭",
  ci: "🇨🇮",
  cm: "🇨🇲",
  ne: "🇳🇪",
  zw: "🇿🇼",
  bf: "🇧🇫",
  ml: "🇲🇱",
  cu: "🇨🇺",
  do: "🇩🇴",
  gt: "🇬🇹",
  ht: "🇭🇹",
  pa: "🇵🇦",
  hn: "🇭🇳",
  sv: "🇸🇻",
  ni: "🇳🇮",
  jm: "🇯🇲",
  tt: "🇹🇹",
  pe: "🇵🇪",
  ve: "🇻🇪",
  bo: "🇧🇴",
  py: "🇵🇾",
  bz: "🇧🇿",
  om: "🇴🇲",
  ye: "🇾🇪",
  sy: "🇸🇾",
  ir: "🇮🇷",
  tm: "🇹🇲",
  kg: "🇰🇬",
  ru: "🇷🇺",
  dk: "🇩🇰",
  mt: "🇲🇹",
  pg: "🇵🇬",
  fj: "🇫🇯",
  sb: "🇸🇧",
  vu: "🇻🇺",
  ws: "🇼🇸",
  ki: "🇰🇮",
  fm: "🇫🇲",
  mh: "🇲🇭",
  pw: "🇵🇼",
  nr: "🇳🇷",
  tv: "🇹🇻",
};

// Función para devolver el emoji o un fallback
const getFlagEmoji = (code) => {
  // Convertimos a minúsculas para asegurarnos de que coincida la llave del objeto
  const lowerCode = code.toLowerCase();
  return flagMap[lowerCode] || "🌎"; // fallback si no existe en el mapa
};

// Tu array de países (abreviado para el ejemplo)
const countries = [
  { id: "1", name: "United States", code: "us" },
  { id: "2", name: "United Kingdom", code: "gb" },
  { id: "3", name: "Japan", code: "jp" },
  { id: "4", name: "France", code: "fr" },
  { id: "5", name: "Italy", code: "it" },
  { id: "6", name: "Brazil", code: "br" },
  { id: "7", name: "Colombia", code: "co" },
  { id: "8", name: "Germany", code: "de" },
  { id: "9", name: "India", code: "in" },
  { id: "10", name: "Canada", code: "ca" },
  { id: "11", name: "South Korea", code: "kr" },
  { id: "12", name: "Australia", code: "au" },
  { id: "13", name: "Spain", code: "es" },
  { id: "14", name: "Mexico", code: "mx" },
  { id: "15", name: "Indonesia", code: "id" },
  { id: "16", name: "Netherlands", code: "nl" },
  { id: "17", name: "Saudi Arabia", code: "sa" },
  { id: "18", name: "Turkey", code: "tr" },
  { id: "19", name: "Switzerland", code: "ch" },
  { id: "20", name: "Taiwan", code: "tw" },
  { id: "21", name: "Sweden", code: "se" },
  { id: "22", name: "Poland", code: "pl" },
  { id: "23", name: "Belgium", code: "be" },
  { id: "24", name: "Thailand", code: "th" },
  { id: "25", name: "Argentina", code: "ar" },
  { id: "26", name: "Norway", code: "no" },
  { id: "27", name: "Austria", code: "at" },
  { id: "28", name: "United Arab Emirates", code: "ae" },
  { id: "29", name: "Nigeria", code: "ng" },
  { id: "30", name: "Israel", code: "il" },
  { id: "31", name: "South Africa", code: "za" },
  { id: "32", name: "Ireland", code: "ie" },
  { id: "33", name: "Hong Kong", code: "hk" },
  { id: "34", name: "Malaysia", code: "my" },
  { id: "35", name: "Singapore", code: "sg" },
  { id: "36", name: "Philippines", code: "ph" },
  { id: "37", name: "Pakistan", code: "pk" },
  { id: "38", name: "Chile", code: "cl" },
  { id: "39", name: "Finland", code: "fi" },
  { id: "40", name: "Bangladesh", code: "bd" },
  { id: "41", name: "Egypt", code: "eg" },
  { id: "42", name: "Vietnam", code: "vn" },
  { id: "43", name: "Portugal", code: "pt" },
  { id: "44", name: "Czech Republic", code: "cz" },
  { id: "45", name: "Romania", code: "ro" },
  { id: "46", name: "New Zealand", code: "nz" },
  { id: "47", name: "Greece", code: "gr" },
  { id: "48", name: "Iraq", code: "iq" },
  { id: "49", name: "Qatar", code: "qa" },
  { id: "50", name: "Kazakhstan", code: "kz" },
  { id: "51", name: "Hungary", code: "hu" },
  { id: "52", name: "Kuwait", code: "kw" },
  { id: "53", name: "Ukraine", code: "ua" },
  { id: "54", name: "Morocco", code: "ma" },
  { id: "55", name: "Slovakia", code: "sk" },
  { id: "56", name: "Ecuador", code: "ec" },
  { id: "57", name: "Sri Lanka", code: "lk" },
  { id: "58", name: "Kenya", code: "ke" },
  { id: "59", name: "Bulgaria", code: "bg" },
  { id: "60", name: "Costa Rica", code: "cr" },
  { id: "61", name: "Uruguay", code: "uy" },
  { id: "62", name: "Croatia", code: "hr" },
  { id: "63", name: "Belarus", code: "by" },
  { id: "64", name: "Lebanon", code: "lb" },
  { id: "65", name: "Lithuania", code: "lt" },
  { id: "66", name: "Slovenia", code: "si" },
  { id: "67", name: "Serbia", code: "rs" },
  { id: "68", name: "Azerbaijan", code: "az" },
  { id: "69", name: "Jordan", code: "jo" },
  { id: "70", name: "Tunisia", code: "tn" },
  { id: "71", name: "Bahrain", code: "bh" },
  { id: "72", name: "Latvia", code: "lv" },
  { id: "73", name: "Estonia", code: "ee" },
  { id: "74", name: "Cyprus", code: "cy" },
  { id: "75", name: "Iceland", code: "is" },
  { id: "76", name: "China", code: "cn" },
  { id: "77", name: "Armenia", code: "am" },
  { id: "78", name: "Albania", code: "al" },
  { id: "79", name: "Bosnia and Herzegovina", code: "ba" },
  { id: "80", name: "North Macedonia", code: "mk" },
  { id: "81", name: "Moldova", code: "md" },
  { id: "82", name: "Montenegro", code: "me" },
  { id: "83", name: "Georgia", code: "ge" },
  { id: "84", name: "Uzbekistan", code: "uz" },
  { id: "85", name: "Afghanistan", code: "af" },
  { id: "86", name: "Nepal", code: "np" },
  { id: "87", name: "Myanmar", code: "mm" },
  { id: "88", name: "Cambodia", code: "kh" },
  { id: "89", name: "Laos", code: "la" },
  { id: "90", name: "Mongolia", code: "mn" },
  { id: "91", name: "Bhutan", code: "bt" },
  { id: "92", name: "Maldives", code: "mv" },
  { id: "93", name: "Brunei", code: "bn" },
  { id: "94", name: "East Timor", code: "tl" },
  { id: "95", name: "Luxembourg", code: "lu" },
  { id: "96", name: "Monaco", code: "mc" },
  { id: "97", name: "San Marino", code: "sm" },
  { id: "98", name: "Andorra", code: "ad" },
  { id: "99", name: "Liechtenstein", code: "li" },
  { id: "100", name: "Vatican City", code: "va" },
  // Países adicionales según la ONU (para completar 150)
  // África (15)
  { id: "101", name: "Algeria", code: "dz" },
  { id: "102", name: "Angola", code: "ao" },
  { id: "103", name: "Ethiopia", code: "et" },
  { id: "104", name: "Democratic Republic of the Congo", code: "cd" },
  { id: "105", name: "Tanzania", code: "tz" },
  { id: "106", name: "Uganda", code: "ug" },
  { id: "107", name: "Sudan", code: "sd" },
  { id: "108", name: "Mozambique", code: "mz" },
  { id: "109", name: "Ghana", code: "gh" },
  { id: "110", name: "Ivory Coast", code: "ci" },
  { id: "111", name: "Cameroon", code: "cm" },
  { id: "112", name: "Niger", code: "ne" },
  { id: "113", name: "Zimbabwe", code: "zw" },
  { id: "114", name: "Burkina Faso", code: "bf" },
  { id: "115", name: "Mali", code: "ml" },
  // Américas (15)
  { id: "116", name: "Cuba", code: "cu" },
  { id: "117", name: "Dominican Republic", code: "do" },
  { id: "118", name: "Guatemala", code: "gt" },
  { id: "119", name: "Haiti", code: "ht" },
  { id: "120", name: "Panama", code: "pa" },
  { id: "121", name: "Honduras", code: "hn" },
  { id: "122", name: "El Salvador", code: "sv" },
  { id: "123", name: "Nicaragua", code: "ni" },
  { id: "124", name: "Jamaica", code: "jm" },
  { id: "125", name: "Trinidad and Tobago", code: "tt" },
  { id: "126", name: "Peru", code: "pe" },
  { id: "127", name: "Venezuela", code: "ve" },
  { id: "128", name: "Bolivia", code: "bo" },
  { id: "129", name: "Paraguay", code: "py" },
  { id: "130", name: "Belize", code: "bz" },
  // Asia (6)
  { id: "131", name: "Oman", code: "om" },
  { id: "132", name: "Yemen", code: "ye" },
  { id: "133", name: "Syria", code: "sy" },
  { id: "134", name: "Iran", code: "ir" },
  { id: "135", name: "Turkmenistan", code: "tm" },
  { id: "136", name: "Kyrgyzstan", code: "kg" },
  // Europa (3)
  { id: "137", name: "Russia", code: "ru" },
  { id: "138", name: "Denmark", code: "dk" },
  { id: "139", name: "Malta", code: "mt" },
  // Oceanía (11)
  { id: "140", name: "Papua New Guinea", code: "pg" },
  { id: "141", name: "Fiji", code: "fj" },
  { id: "142", name: "Solomon Islands", code: "sb" },
  { id: "143", name: "Vanuatu", code: "vu" },
  { id: "144", name: "Samoa", code: "ws" },
  { id: "145", name: "Kiribati", code: "ki" },
  { id: "146", name: "Federated States of Micronesia", code: "fm" },
  { id: "147", name: "Marshall Islands", code: "mh" },
  { id: "148", name: "Palau", code: "pw" },
  { id: "149", name: "Nauru", code: "nr" },
  { id: "150", name: "Tuvalu", code: "tv" },
];

const CountryChips = ({ selectedCountryCode, onChangeCountryCode }) => {
  return (
    <div className="flex items-center gap-2 px-4 sm:px-10 lg:px-16 border-b mb-4 overflow-x-auto no-scrollbar mt-4">
      {/* Chip "All Countries" */}
      <button
        onClick={() => onChangeCountryCode("0")}
        className={`inline-flex items-center gap-2 px-4 py-2 rounded-full
          ${
            selectedCountryCode === "0"
              ? "bg-black text-white"
              : "bg-gray-200 text-gray-800 hover:bg-gray-300"
          }
          transition-colors whitespace-nowrap
        `}
      >
        <span>🌎</span>
        <span>All Countries</span>
      </button>

      {/* Chips de cada país */}
      {countries.map((country) => (
        <button
          key={country.id}
          onClick={() => onChangeCountryCode(country.code)}
          className={`inline-flex items-center gap-2 px-4 py-2 rounded-full
          ${
            selectedCountryCode === country.code
              ? "bg-black text-white"
              : "bg-gray-200 text-gray-800 hover:bg-gray-300"
          }
          transition-colors whitespace-nowrap
        `}
        >
          <span>{getFlagEmoji(country.code)}</span>
          <span>{country.name}</span>
        </button>
      ))}
    </div>
  );
};

export default CountryChips;

